import * as preloadUtilities from '@alme/ui-web/ref/utilities-preload';
import { instantiateClient, getClientInstance } from './client-instance.js';
import { getSettings } from '@alme/ui-web/settings/settings-util';
import { InitializeSettings } from '../settings/init-settings';

require('../styles/themes/_theme_default.scss');
require('../styles/themes/_theme_hrx.scss');
require('../styles/themes/_theme_worklife.scss');
require('../styles/themes/_theme_embedded.scss');

const settings = getSettings();
InitializeSettings();

preloadUtilities.injectAgentContainer(settings.Window.rootId);
instantiateClient(settings);

const almeWebClient = getClientInstance();
almeWebClient.initialize();
almeWebClient.start();

export { almeWebClient };

function getNewHostName(launchScriptId) {
    const scriptTag = document.getElementById(launchScriptId);
    const url = scriptTag.getAttribute('src');

    if (url.indexOf('../') === 0) {
        return location.host;
    }
    else {
        return url.substr(0, url.toLowerCase().lastIndexOf('/alme/')).replace("http://", "").replace("https://", "");
    }
}




// WEBPACK FOOTER //
// ./src/implementation.js